import { render, staticRenderFns } from "./BasicSettings.vue?vue&type=template&id=4780c644"
import script from "./BasicSettings.vue?vue&type=script&lang=js"
export * from "./BasicSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports